import { LinkOff as LinkOffIcon } from '@mui/icons-material'
import { Button, Divider, Stack, Typography } from '@mui/material'
import React, { useState } from 'react'
import InfoBlock from '../../components/InfoBlock'
import { CompanyEvents } from './CompanyEvents'
import { SourceTypeButtons } from './SourceTypeButtons'

export const sortAndSetIssuesFunction = (issues) => {
    if (!issues) return []

    const sortedIssues = issues.sort((a, b) => {
        // First sort by statusComplete (0 before 1)
        if (a.statusComplete !== b.statusComplete) {
            return a.statusComplete - b.statusComplete
        }

        // If statusComplete values are the same, sort by date
        const s1 = new Date(a.subEndDate ? a.subEndDate : a.publicationDate)
        const s2 = new Date(b.subEndDate ? b.subEndDate : b.publicationDate)

        return s2 - s1 // Newest dates first
    })

    return sortedIssues
}

export const CompanyTargets = ({
    selectedTargets,
    setSelectedTargets,
    associatedPRs,
    setAssociatedPRs,
    sourceType,
    setSourceType,
    selectedCompany,
    selectedPR,
    onArchivePR,
    onDisconnectCompany,
}) => {
    const [issues, setIssues] = useState(null)
    const [entityType, setEntityType] = useState(null) // Only used for Convertibles at the moment, should be extended for other entity types as well

    if (!selectedCompany || !selectedPR) return null
    return (
        <InfoBlock title='Emissioner, Teckningsoptioner och Konvertibler'>
            <Stack direction='row' spacing={6} alignItems='center'>
                <Typography variant='h6'>{selectedCompany.name}</Typography>
                <Button
                    variant='outlined'
                    startIcon={<LinkOffIcon />}
                    onClick={() => onDisconnectCompany(selectedCompany)}
                >
                    Koppla bort
                </Button>
            </Stack>
            <Divider my={6} />
            <SourceTypeButtons
                entityType={entityType}
                selectedSourceType={sourceType}
                setSelectedSourceType={setSourceType}
            />
            <Divider my={6} />
            <CompanyEvents
                setEntityType={setEntityType}
                sourceType={sourceType}
                setSourceType={setSourceType}
                company={selectedCompany}
                selectedTargets={selectedTargets}
                setSelectedTargets={setSelectedTargets}
                associatedPRs={associatedPRs}
                setAssociatedPRs={setAssociatedPRs}
                issues={issues}
                setIssues={setIssues}
                selectedPR={selectedPR}
                onArchivePR={onArchivePR}
            />
        </InfoBlock>
    )
}
